import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/Header.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/app/globals.css");
